import "./AllRefundRequest.css";

import React from "react";

import Headers from "Components/Header/Headers";
import Navigation from "Components/SideNavBar/Navigation";
import RefundStatusActions from "../../Common/RefundStatusActions";
import StripeOnboardingRequiredPopup from "Components/Popup/StripeOnboardingRequiredPopup/StripeOnboardingRequiredPopup";
import useRefundRequests from "../../Common/useRefundRequests";

const COLUMNS = [
  { label: "DATE", render: (curr) => curr?.dateTime },
  { label: "TRANSACTION ID", render: (curr) => curr?.transactionId },
  { label: "REQUESTOR ORG", render: (curr) => curr?.requestorOrg },
  { label: "REASON", render: (curr) => curr?.reason },
  {
    label: "CREDITS",
    contentStyle: { color: "#5CA127", fontWeight: "bold" },
    render: (curr) => curr?.credit,
  },
];

const AllRefundRequest = () => {
  const {
    loader,
    requestList,
    handleSearchInput,
    filterData,
    changeStatus,
    showStripeOnboardingPopup,
    setShowStripeOnboardingPopup,
    stripeDashboardUrl,
  } = useRefundRequests();

  return (
    <>
      <div className="all-refund-request-parent">
        <div className="all-refund-request-header">
          <Headers />
        </div>

        <div className="all-refund-request-navigation">
          <Navigation />
        </div>

        <div className="all-refund-request-main">
          <div className="all-refund-request-wrapper">
            <div className="all-refund-request-heading">
              Refund Request Page
            </div>
            <div className="all-refund-request-all-active">
              <div className="all-refund-request-top">
                <input
                  type="search"
                  placeholder="Search"
                  onChange={(e) => handleSearchInput(e.target.value)}
                />
                <div>
                  <p>Filter:</p>
                  <select onClick={(e) => filterData(e.target.value)}>
                    <option value="all">All</option>
                    <option value="pending">PENDING</option>
                    <option value="approved">APPROVED</option>
                    <option value="rejected">REJECTED</option>
                  </select>
                </div>
              </div>
              <div className="all-refund-request-row-wrapper">
                {[...COLUMNS, { label: "ACTIONS" }].map(({ label }) => (
                  <div key={label} className="all-refund-request-head-row">
                    {label}
                  </div>
                ))}
              </div>
              <div className="all-refund-request-bottom">
                {requestList?.length?.toString() !== "0" ? (
                  requestList?.map((curr, index) => (
                    <div
                      className="all-refund-request-content-wrapper"
                      key={index}
                    >
                      {COLUMNS.map(({ label, contentStyle, render }) => (
                        <div
                          key={label}
                          className="all-refund-request-content-row"
                          style={contentStyle}
                        >
                          {render(curr)}
                        </div>
                      ))}
                      <div className="all-refund-request-content-row">
                        <RefundStatusActions
                          request={curr}
                          changeStatus={changeStatus}
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="all-refund-request-msg">
                    No Requests Found
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {showStripeOnboardingPopup && (
        <StripeOnboardingRequiredPopup
          hide={setShowStripeOnboardingPopup}
          dashboardUrl={stripeDashboardUrl}
        />
      )}
      {loader}
    </>
  );
};

export default AllRefundRequest;
